import { getComponentName } from '../../helpers/componentHelpers';
import { createCssVarImageClass } from '../../baseClasses/createCssVarImageClass';

export const componentName = getComponentName('logo');

export const LogoClass = createCssVarImageClass({
  componentName,
  varName: 'url',
  fallbackVarName: 'fallbackUrl',
});
